
<div class="row align-items-center">
  <div class="col">
  </div>

  <div class="col text-right">
  <a placement="bottom" ngbTooltip="Create" class="ml-3">
    <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/apiCreate" width="30" height="30" viewBox="0 0 30 30">
      <defs>
        <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
      </defs>
      <g transform="translate(4 2.5)">
        <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
        <path class="b"
              d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
              transform="translate(2.823 3.938)"/>
      </g>
    </svg>
  </a>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="inner-box d-none d-sm-block">

      <div class="table-3">
      <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead class="thead-light">
            <tr>
              <th>API Name</th>
              <th>API Key</th>
              <th>Secret Key</th>
              <th>URL</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody class="table-body-custom">
            <tr *ngFor="let data of accessKey">
              <td><a class="ml-2" routerLink="/admin/apiView/{{data.id}}">{{data.apiName}}</a></td>
              <td>{{data.apiKey}}</td>
              <td>{{data.secretKey}}</td>
              <td>{{data.redirectUrl}}</td>
              <td><a data-toggle="modal" (click)="deleteApi(data)"
                     class="p-2 ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                  <defs><style>.a{fill:#848484;}</style></defs>
                  <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                </svg>
              </a> </td>
            </tr>
            </tbody>
          </table>
      </div>

        </div>

    </div>
  </div>



<!--Delete model-box two-->
  <div class="modal show fade" id="deleteApiPop" [ngStyle]="{'display': deletePopUp =='Y'? 'block' : 'none'}" [ngClass]="{'modal': deletePopUp == 'Y'}" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteApis()">Yes</button>
        </div>
      </div>
    </div>
  </div>

<div [ngStyle]="{'display': createApiPopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': createApiPopUp == 'Y'}" id="exampleModalPreview" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel">API</h5>
        <button type="button" class="close " (click)="closePopUp()" data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <div class="inner-box">
                <div class="row mt-3">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="api">Api Key</label>
                      <input type="text" id="api" [(ngModel)]="getApiKey" class="form-control" disabled [ngModelOptions]="{standalone: true}"  required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="secretKey">Secret Key</label>
                      <input type="text" id="secretKey" [(ngModel)]="getSecretKey" class="form-control" disabled [ngModelOptions]="{standalone: true}" #userInput required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="url">URL</label>
                      <input type="text" id="url" [(ngModel)]="url" [ngClass]="{'is-invalid':urlError}" class="form-control" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                </div>
                <!--        <a data-toggle="modal" data-target="#deleteApiPop" (click)="deleteApi(accessKey)"
                           class="p-2 mt-4 ml-3">
                          <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                            <defs><style>.a{fill:#848484;}</style></defs>
                            <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                          </svg>
                        </a>
                            <div class="col-md-12">
                          <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!accessKeyErrorMessage">{{accessKeyErrorMessage}}</div>
                            </div>-->

                <!--
            <label class="text-danger"><b>Note: The secret key will not be displayed in future, so have this information securely</b></label>
          -->

                <div class="row">
                  <div class="col-md-12 text-right">
                    <button type="submit"  class="btn btn-orange" (click)="save()">Save</button>
                    <button type="submit"  class="btn btn-orange ml-1" (click)="keyGenerate()" [disabled]="getApiKey || getSecretKey">Generate</button>
                  </div>
                  <!--
                            <a (click)="copyInputMessage(userInput)">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-clipboard-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                <path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zM8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/>
                              </svg>
                            </a>
                  -->
                </div>

              </div>
              <div class="row mb-5">
                <div class="col-6">
                  <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:0: sliceUPto(openList?.length)">
                    <table class="table" >
                      <thead>
                      <tr>
                        <th>{{notification.groupName}}</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let n of notification?.apiSettingsResponses">
                        <td width="25%">
                          <div class="toggle-2">
                            <input type="checkbox" name="onoffswitch" id="{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" (change)="openUpdateStatus(n,notification.id)" class="checkbox"/>
                            <label for="{{n.typeName}}" class="toggle">
                              <span>ON</span><span>OFF</span>
                            </label>
                          </div>
                          <!--
                                            <div class="custom-control custom-switch">
                                            <input type="checkbox"  class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" id="{{n.typeName}}" (change)="updateStatus(n,notification.id)">
                                            <label class="custom-control-label" for="{{n.typeName}}"> </label>
                                          </div>
                          -->
                        </td>
                        <td>{{n?.typeName}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-6">
                  <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:sliceUPto(openList?.length):openList?.length">
                    <table class="table" >
                      <thead>
                      <tr>
                        <th>{{notification.groupName}}</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let n of notification?.apiSettingsResponses">
                        <td width="25%">
                          <div class="toggle-2">
                            <input type="checkbox" name="onoffswitch" id="c-{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" (change)="openUpdateStatus(n,notification.id)" class="checkbox"/>
                            <label for="c-{{n.typeName}}" class="toggle">
                              <span>ON</span><span>OFF</span>
                            </label>
                          </div>
                          <!--
                                            <div class="custom-control custom-switch">
                                            <input type="checkbox"  class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" id="{{n.typeName}}" (change)="updateStatus(n,notification.id)">
                                            <label class="custom-control-label" for="{{n.typeName}}"> </label>
                                          </div>
                          -->
                        </td>
                        <td>{{n?.typeName}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': viewPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': viewPopup == 'Y'}" id="viewPopup" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="viewPopups">View Details</h5>
        <button type="button" class="close " (click)="closeViewPopUp()" data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <div class="inner-box">
                <div class="row mt-3">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="api">Api Key</label>
                      <input type="text" id="apiv" [(ngModel)]="viewData.apiKey" class="form-control" disabled [ngModelOptions]="{standalone: true}"  required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="secretKey">Secret Key</label>
                      <input type="text" id="secretKeyv" [(ngModel)]="viewData.secretKey" class="form-control" disabled [ngModelOptions]="{standalone: true}" #userInput required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="control-label" for="url">URL</label>
                      <input type="text" id="urlv" [(ngModel)]="viewData.redirectUrl" [ngClass]="{'is-invalid':urlError}" class="form-control" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 text-right">
                    <button type="submit"  class="btn btn-orange" (click)="closeViewPopUp()">Close</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
